import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavbarService } from 'src/app/navbar.service';


@Component({
  selector: 'app-navabr',
  templateUrl: './navabr.component.html',
  styleUrls: ['./navabr.component.css']
})
export class NavabrComponent implements OnInit {

  userDisplayName: any;
  constructor(public nav:NavbarService, public router:Router) { }
  ngOnInit(): void {
    this.userDisplayName = localStorage.getItem('username');

    // console.log(this.userDisplayName);
    
    // alert(this.userDisplayName);
    
  }

  logout(){
    localStorage.clear();
    this.router.navigate(['/']);
  }
}
